import React from 'react';

const Modal = (props) => {
	const {
		title = "",
		onOk = () => { },
		onClose = () => { },
		okText = "OK",
		cancelText = "Cancel",
		modalBody = <></>,
		isOkButtonDisabled = false,
		isFooterVisible = true
	} = props;

	return <div
		id="appModal"
		className="modal"
		style={{
			display: "block",
			background: "#9e9fa37a",
			pointerEvents: "none",
			visibility: "visible !important"
		}}
	>
		<div className="modal-dialog">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title" style={{ "fontWeight": "600" }} >{title}</h5>
					<button
						type="button"
						className="btn-close"
						data-bs-dismiss="modal"
						onClick={onClose}
					/>
				</div>
				<div className="modal-body">
					{modalBody}
				</div>
				<div className="modal-footer text-end " style={{ display: isFooterVisible ? "block" : "none" }}>
					<button type="button" className="btn btn-secondary" onClick={onClose} >
						{cancelText}
					</button>
					<button type="button" className="btn btn-secondary" onClick={onOk} disabled={isOkButtonDisabled}>
						{okText}
					</button>
				</div>
			</div>
		</div>
	</div>
};

export default Modal;
